/**
 * Copyright (c) Qwoach LLC 2025. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 30.06.25
 *
 */
import LineItem from "@shared/Invoice/LineItem";
import DbBaseObject from "@shared/DbBaseObject";
import {Type} from "@qwoach/class-transformer-wrapper";
import {ServiceType} from "@shared/Quote/ServiceType";

export default class DraftLineItem extends DbBaseObject {

	@Type(() => LineItem)
	lineItem: LineItem = null;

	clientId: string = null;
	isBillingSuspended: boolean = false;

	getCurrentSchemaVersion() {
		return 2;
	}

	migrateSchema(oldVersion, newVersion) {
		super.migrateSchema(oldVersion, newVersion);
		if (oldVersion < 2 && this.lineItem?.serviceType === ServiceType.SESSION
			&& (this.lineItem.subLineItems || []).some(child => !child.sourceServiceId)) {
			LineItem.normalizeSessionDerivedSubItems(this.lineItem);
		}
	}

	constructor(options = {}) {
		super(options);
		let lineItem = options.lineItem || options
		if(lineItem instanceof LineItem) {
			this.lineItem = lineItem;
		} else {
			this.lineItem = new LineItem(options);
		}

		//trigger regeneration of id after lineItem is set to ensure the ids are in sync
		this.generateId()

		this.clientId = options.clientId || null;
		this.isBillingSuspended = options.isBillingSuspended || false;

	}

	setLineItem(lineItem) {
		if(this.lineItem && this.lineItem.id !== lineItem.id) {
			//if the line item id is different, we need to regenerate the id of the draft line item
			console.warn("DraftLineItem.setLineItem: line item id is different. Make sue the ids are the same. Ignoring.");
			return false
		}
		this.lineItem = lineItem;
		this.regenerateId();
		return true
	}

	regenerateId(){
		//we keep the id of DraftLineItem the same as the lineItem id to keep track of changed in db
		if(this.lineItem){
			this.id = this.lineItem.id;
		} else {
			super.regenerateId();
		}
	}


	getDateMs(){
		return this.lineItem.serviceDateMs;
	}


	getTotalPrice() {
		return this.lineItem.getTotalPrice();
	}

	breakdownFormatted(currencyCode, options = {}) {
		return this.lineItem.breakdownFormatted(currencyCode, options);
	}
}
